import React, { useEffect, useState } from 'react';
import {
  Dimensions,
  Platform,
  Pressable,
  StyleSheet,
  Text,
  View,
} from 'react-native';

const windowWidth = Dimensions.get('window').width;

const NAV_HEIGHT = 60;

export function Tutorial({ items, dismiss }) {
  const [index, setIndex] = useState(0);
  const [currentItem, setCurrentItem] = useState(items[index]);
  const [position, setPosition] = useState({
    top: null,
    left: null,
    width: null,
    height: null,
    boxLeft: null,
    boxTop: null,
    transform: null,
  });
  const [size, setSize] = useState({ width: 0, height: 0 });
  const styles = setStyles(windowWidth);

  useEffect(() => {
    if (currentItem.ref?.current?.measure) {
      currentItem.ref.current.measure(
        (
          left: number,
          top: number,
          width: number,
          height: number,
          pageX: number,
          pageY: number,
        ) => {
          // Full page
          if (width === windowWidth) {
            setPosition({
              top: 0,
              left: 0,
              boxTop: 50,
              boxLeft: 0,
              width,
              height,
              transform: windowWidth / 2 - size.width / 2,
            });
          } else if (pageX > size.width) {
            // Render to the left
            setPosition({
              top: pageY - 5 - NAV_HEIGHT,
              left: pageX - 5,
              boxLeft: pageX,
              width: width + 10,
              height: height + 10,
              transform: -(size.width + 20),
              boxTop: pageY - NAV_HEIGHT,
            });
          } else {
            // Render to the right
            setPosition({
              top: pageY - 5 - NAV_HEIGHT,
              left: pageX - 5,
              boxLeft: position.width + 20,
              width: width + 10,
              height: height + 10,
              transform: 0,
              boxTop: pageY - NAV_HEIGHT,
            });
          }
        },
      );
    }
  }, [currentItem, position.width, setPosition, size]);

  useEffect(() => {
    setCurrentItem(items[index]);
  }, [index, items]);

  return (
    <View style={styles.top}>
      <View
        style={[
          styles.container,
          {
            top: position.boxTop,
            left: position.boxLeft,
            transform: `translateX(${position.transform}px)`,
          },
        ]}
        onLayout={(e) => {
          const { width, height } = e.nativeEvent.layout;
          setSize({ width, height });
        }}
      >
        <View style={styles.textContainer}>
          {currentItem.title && (
            <Text style={styles.title}>{currentItem.title}</Text>
          )}
          {currentItem.body && (
            <Text style={styles.body}>{currentItem.body}</Text>
          )}
        </View>
        <View style={styles.buttonContainer}>
          <Pressable onPress={() => dismiss()}>
            <Text style={styles.button}>Exit</Text>
          </Pressable>
          <Pressable disabled={index <= 0} onPress={() => setIndex(index - 1)}>
            <Text style={styles.button}>Back</Text>
          </Pressable>
          {index < items.length - 1 && (
            <Pressable onPress={() => setIndex(index + 1)}>
              <Text style={styles.button}>Next</Text>
            </Pressable>
          )}
        </View>
      </View>
      <View
        testID="FocusBox"
        style={[
          styles.focus,
          {
            width: position.width,
            height: position.height,
            left: position.left,
            top: position.top,
          },
        ]}
      />
    </View>
  );
}

const setStyles = (width: number) =>
  StyleSheet.create({
    top: {
      position: 'absolute',
      zIndex: 9999,
    },
    container: {
      position: 'absolute',
      zIndex: 9999,
      backgroundColor: '#fff',
      padding: 10,
      borderRadius: 10,
      shadowRadius: 5,
      shadowOpacity: 0.2,
      width: width > 900 ? 300 : 100,
      minWidth: 200,
    },
    title: {
      fontSize: 20,
      fontWeight: 'bold',
    },
    body: {
      fontSize: 16,
    },
    textContainer: {
      marginBottom: 10,
    },
    buttonContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
    },
    button: {
      fontSize: 16,
      fontWeight: 'bold',
      marginLeft: 10,
    },
    focus: {
      position: 'absolute',
      left: 0,
      top: 0,
      width: 100,
      height: 100,
      borderColor: '#3cc4d5',
      borderWidth: 3,
      borderRadius: 5,
      ...(Platform.OS === 'web'
        ? {
            'box-shadow': '0px 0px 0px 2000px rgba(0, 0, 0, 0.5)',
          }
        : {
            shadowRadius: 2000,
            shadowOffset: {
              width: 0,
              height: 0,
            },
            shadowOpacity: 0.5,
          }),
    },
  });
